export default "__VITE_ASSET__C0AG2x0t__"